export default "__VITE_ASSET__4Llq3ViM__"